/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Empty_Submit_CtaInputs */

const en_directory_empty_submit_cta = /** @type {(inputs: Directory_Empty_Submit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a tool`)
};

const zh_directory_empty_submit_cta = /** @type {(inputs: Directory_Empty_Submit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具`)
};

/**
* | output |
* | --- |
* | "Submit a tool" |
*
* @param {Directory_Empty_Submit_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_empty_submit_cta = /** @type {((inputs?: Directory_Empty_Submit_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Empty_Submit_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_empty_submit_cta(inputs)
	return zh_directory_empty_submit_cta(inputs)
});
export { directory_empty_submit_cta as "directory.empty.submit_cta" }